/* Labesny reviews on labesny.com.
 *
 * Three jobs, all reading from the Labesny app's backend (window.FIG.api, the theme setting
 * "App backend address"), where reviews are kept, shared with the app and moderated:
 *
 *   1. Stars on product cards, for every card on the page, fetched in batches as cards appear.
 *   2. The rating line under the product title, linking down to the reviews.
 *   3. The reviews section (sections/fig-reviews.liquid): summary, fit, "What customers say",
 *      customer photos with a full-screen viewer, the reviews, and the drawer to write one with
 *      photos, which are shrunk in the browser before they are sent.
 *
 * Nothing here is required for the page to work: with no address, or a backend that does not
 * answer, every part stays hidden.
 */
(function () {
  "use strict";
  var FIG = window.FIG || {};
  var API = (FIG.api || "").replace(/\/$/, "");
  if (!API) return;

  var DIR = document.documentElement.getAttribute("dir") === "rtl" ? "rtl" : "ltr";
  var LANG = DIR === "rtl" ? "ar" : "en";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };
  var get = function (path) {
    return fetch(API + path, { credentials: "omit" }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  };
  var stars = function (r, cls) {
    return '<span class="rv-stars' + (cls ? " " + cls : "") + '" style="--r:' + (Number(r) || 0) + '" role="img" aria-label="' + (Math.round(r * 10) / 10) + ' / 5"></span>';
  };
  /* Latin figures in both languages, as the prices on the site are. */
  var num = function (n) { return new Intl.NumberFormat("en", { maximumFractionDigits: 1 }).format(n); };

  /* ── 1. stars on product cards ───────────────────────────────────── */
  var seen = new WeakSet();
  var queue = [];
  var timer = null;
  function collectCards(root) {
    $$(".card[data-handle]", root).forEach(function (c) {
      if (seen.has(c)) return;
      seen.add(c);
      queue.push(c);
    });
    if (queue.length && !timer) timer = setTimeout(flush, 150);
  }
  function flush() {
    timer = null;
    var batch = queue.splice(0, 100);
    if (!batch.length) return;
    var handles = batch.map(function (c) { return c.dataset.handle; });
    get("/hooks/reviews?handles=" + encodeURIComponent(handles.join(","))).then(function (d) {
      batch.forEach(function (c) {
        var r = d.ratings && d.ratings[c.dataset.handle];
        if (!r || !r.count || $(".c-rate", c)) return;
        var info = $(".card-info", c);
        if (!info) return;
        var el = document.createElement("p");
        el.className = "c-rate";
        el.innerHTML = stars(r.average) + '<span>' + num(r.average) + " (" + r.count + ")</span>";
        var brand = $(".c-brand", info);
        if (brand && brand.nextSibling) info.insertBefore(el, brand.nextSibling);
        else info.appendChild(el);
      });
    }).catch(function () {});
    if (queue.length) timer = setTimeout(flush, 150);
  }
  collectCards(document);
  new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      m.addedNodes.forEach(function (n) { if (n.nodeType === 1) collectCards(n); });
    });
  }).observe(document.body, { childList: true, subtree: true });

  /* ── 3. the reviews section ──────────────────────────────────────── */
  var sec = $("[data-reviews]");
  if (!sec) return;
  var T = {};
  try { T = JSON.parse($("[data-rv-t]").textContent); } catch (e) {}
  var t = function (k, a, b) {
    return String(T[k] || k).replace("%n", a).replace("%s", a).replace("%a", a).replace("%b", b);
  };
  var body = $("[data-rv-body]", sec);
  var handle = sec.dataset.handle;
  var state = { sort: "recent", rating: 0, photos: false, offset: 0, data: null, list: [] };
  var LIMIT = 6;
  var labels = (T.stars || "").split("|");
  var rel = (function () {
    try { var f = new Intl.RelativeTimeFormat(LANG, { numeric: "auto" }); } catch (e) { return function (d) { return new Date(d).toLocaleDateString(); }; }
    return function (iso) {
      var s = (Date.now() - new Date(iso).getTime()) / 1000;
      var steps = [[60, "second"], [60, "minute"], [24, "hour"], [7, "day"], [4.35, "week"], [12, "month"], [Infinity, "year"]];
      var v = s;
      for (var i = 0; i < steps.length; i++) {
        if (Math.abs(v) < steps[i][0]) return f.format(-Math.round(v), steps[i][1]);
        v /= steps[i][0];
      }
      return "";
    };
  })();

  function load(append) {
    var q = "?handle=" + encodeURIComponent(handle) + "&sort=" + state.sort + "&limit=" + LIMIT + "&offset=" + state.offset +
      (state.rating ? "&rating=" + state.rating : "") + (state.photos ? "&photos=1" : "");
    return get("/hooks/reviews" + q).then(function (d) {
      state.data = d;
      state.list = append ? state.list.concat(d.reviews) : d.reviews;
      render();
    });
  }

  function rateLine(d) {
    var el = $("[data-p-rate]");
    if (!el) return;
    if (!d.stats.count) { el.hidden = true; return; }
    el.innerHTML = stars(d.stats.average) + "<span>" + num(d.stats.average) + "</span><u>" + (d.stats.count === 1 ? t("one") : t("many", d.stats.count)) + "</u>";
    el.hidden = false;
  }

  function summaryHtml(d) {
    var s = d.stats;
    var bars = s.stars.map(function (n, i) {
      var star = 5 - i;
      var pct = s.count ? Math.round((n / s.count) * 100) : 0;
      return '<button type="button" class="rv-bar' + (state.rating === star ? " on" : "") + '" data-rate="' + star + '"' + (n ? "" : " disabled") + ">" +
        "<span>" + star + '<i class="rv-mini-star"></i></span><b><i style="width:' + pct + '%"></i></b><em>' + n + "</em></button>";
    }).join("");
    var fit = "";
    if (s.fit_lean !== null) {
      var pos = 50 + s.fit_lean * 50;
      var word = s.fit_lean < -0.25 ? t("fit_small") : s.fit_lean > 0.25 ? t("fit_large") : t("fit_true");
      fit = '<div class="rv-fit"><p class="rv-k">' + t("fit_title") + '</p><p class="rv-fit-w">' + esc(word) + "</p>" +
        '<div class="rv-fit-track"><i style="inset-inline-start:' + pos + '%"></i></div>' +
        '<div class="rv-fit-ends"><span>' + t("fit_small") + "</span><span>" + t("fit_true") + "</span><span>" + t("fit_large") + "</span></div></div>";
    }
    return '<div class="rv-sum">' +
      '<div class="rv-score"><p class="rv-big">' + num(s.average) + "</p>" + stars(s.average, "lg") +
      '<p class="rv-count">' + (s.count === 1 ? t("one") : t("many", s.count)) + "</p>" +
      (s.recommend ? '<p class="rv-rec">' + t("recommend", s.recommend) + "</p>" : "") + "</div>" +
      '<div class="rv-bars">' + bars + "</div>" + fit +
      '<div class="rv-cta"><button type="button" class="btn" data-rv-write>' + t("write") + "</button></div></div>";
  }

  function aiHtml(d) {
    if (!d.summary) return "";
    var text = LANG === "ar" ? d.summary.ar : d.summary.en;
    var tags = (d.summary.highlights || []).map(function (h) { return "<li>" + esc(LANG === "ar" ? h.ar : h.en) + "</li>"; }).join("");
    return '<aside class="rv-ai"><p class="rv-ai-k"><span aria-hidden="true">✦</span> ' + t("say") + "</p><p class=\"rv-ai-t\">" + esc(text) + "</p>" +
      (tags ? '<ul class="rv-tags">' + tags + "</ul>" : "") + '<p class="rv-ai-n">' + t("ai_note") + "</p></aside>";
  }

  function galleryHtml(d) {
    if (!d.gallery.length) return "";
    return '<div class="rv-gal"><p class="rv-k">' + t("photos") + ' <span>' + d.gallery.length + "</span></p><div class=\"rv-gal-row\">" +
      d.gallery.map(function (g, i) {
        return '<button type="button" data-gal="' + i + '" aria-label="' + esc(g.author_name) + '"><img src="' + esc(g.url) + '" alt="" loading="lazy"></button>';
      }).join("") + "</div></div>";
  }

  function toolsHtml() {
    var sorts = ["recent", "helpful", "highest", "lowest"].map(function (k) {
      return '<option value="' + k + '"' + (state.sort === k ? " selected" : "") + ">" + t("sort_" + k) + "</option>";
    }).join("");
    var chips = '<button type="button" class="rv-chip' + (!state.rating && !state.photos ? " on" : "") + '" data-filter="all">' + t("all") + "</button>" +
      '<button type="button" class="rv-chip' + (state.photos ? " on" : "") + '" data-filter="photos">' + t("with_photos") + "</button>" +
      (state.rating ? '<button type="button" class="rv-chip on" data-filter="clear-rate">' + state.rating + ' <i class="rv-mini-star"></i> ×</button>' : "");
    return '<div class="rv-tools"><div class="rv-chips">' + chips + '</div><label class="rv-sort"><select data-sort aria-label="Sort">' + sorts + "</select></label></div>";
  }

  function cardHtml(r, i) {
    var long = r.body.length > 320;
    var photos = (r.photos || []).map(function (p, k) {
      return '<button type="button" data-rp="' + i + ":" + k + '"><img src="' + esc(p.url) + '" alt="" loading="lazy"></button>';
    }).join("");
    var meta = [];
    if (r.size_bought) meta.push('<span class="rv-tag">' + t("size", esc(r.size_bought)) + "</span>");
    if (r.fit) meta.push('<span class="rv-tag">' + t("fit_" + r.fit) + "</span>");
    /* The shop's own words follow the page; only what the customer wrote follows their language. */
    var tdir = ' dir="' + (r.lang === "ar" ? "rtl" : "ltr") + '"';
    return '<article class="rv-card' + (r.featured ? " pinned" : "") + '">' +
      '<div class="rv-card-top">' + stars(r.rating) + '<time datetime="' + esc(r.created_at) + '">' + rel(r.created_at) + "</time></div>" +
      (r.title ? '<h3 class="rv-title"' + tdir + ">" + esc(r.title) + "</h3>" : "") +
      '<p class="rv-text' + (long ? " clamp" : "") + '"' + tdir + ">" + esc(r.body) + "</p>" +
      (long ? '<button type="button" class="rv-more" data-expand>' + t("read_more") + "</button>" : "") +
      (photos ? '<div class="rv-photos">' + photos + "</div>" : "") +
      (meta.length ? '<div class="rv-meta">' + meta.join("") + "</div>" : "") +
      '<div class="rv-who"><span class="rv-av" aria-hidden="true">' + esc((r.author_name || "?").charAt(0)) + "</span><b><bdi>" + esc(r.author_name) + "</bdi></b>" +
      (r.verified ? '<span class="rv-ver"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7"/></svg>' + t("verified") + "</span>" : "") + "</div>" +
      (r.reply ? '<div class="rv-reply"><p class="rv-k">' + t("reply") + "</p><p>" + esc(r.reply) + "</p></div>" : "") +
      '<div class="rv-foot"><button type="button" class="rv-help" data-help="' + esc(r.id) + '"' + (helped(r.id) ? " disabled" : "") + '>' +
      '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M6 9l3-6c1.2 0 2 .9 2 2v3h4.2c1 0 1.7.9 1.5 1.9l-1.2 6c-.2.7-.8 1.1-1.5 1.1H6m0-8H3v8h3m0-8v8"/></svg>' +
      t("helpful") + (r.helpful ? " · " + r.helpful : "") + "</button></div></article>";
  }

  function helped(id) { try { return (JSON.parse(localStorage.getItem("lab-helped")) || []).indexOf(id) >= 0; } catch (e) { return false; } }

  function render() {
    var d = state.data;
    rateLine(d);
    /* No reviews yet: the block stays hidden (UI review P5: an empty "Be the first" block with a big
       black button added doubt, not trust). It shows once the piece has its first review. */
    if (!d.stats.count) { sec.hidden = true; return; }
    sec.hidden = false;
    var list = state.list.length
      ? '<div class="rv-list">' + state.list.map(cardHtml).join("") + "</div>"
      : '<p class="rv-none">' + t("none") + "</p>";
    var more = state.list.length < d.count ? '<div class="rv-more-wrap"><button type="button" class="btn outline" data-more>' + t("more") + "</button></div>" : "";
    body.innerHTML = '<div class="rv-grid"><div class="rv-side">' + summaryHtml(d) + "</div><div class=\"rv-main\">" + aiHtml(d) + galleryHtml(d) + toolsHtml() + list + more + "</div></div>";
  }

  body.addEventListener("click", function (e) {
    var el;
    if ((el = e.target.closest("[data-rv-write]"))) return openWriter();
    if ((el = e.target.closest("[data-rate]"))) {
      var r = Number(el.dataset.rate);
      state.rating = state.rating === r ? 0 : r;
      state.offset = 0;
      return load();
    }
    if ((el = e.target.closest("[data-filter]"))) {
      var f = el.dataset.filter;
      if (f === "all") { state.rating = 0; state.photos = false; }
      if (f === "photos") state.photos = !state.photos;
      if (f === "clear-rate") state.rating = 0;
      state.offset = 0;
      return load();
    }
    if ((el = e.target.closest("[data-more]"))) {
      state.offset += LIMIT;
      el.disabled = true;
      return load(true);
    }
    if ((el = e.target.closest("[data-expand]"))) {
      el.previousElementSibling.classList.remove("clamp");
      el.remove();
      return;
    }
    if ((el = e.target.closest("[data-gal]"))) {
      var g = state.data.gallery;
      return viewer(g.map(function (x) { return { url: x.url, who: x.author_name, review: findReview(x.review_id) }; }), Number(el.dataset.gal));
    }
    if ((el = e.target.closest("[data-rp]"))) {
      var parts = el.dataset.rp.split(":");
      var rv = state.list[Number(parts[0])];
      return viewer(rv.photos.map(function (p) { return { url: p.url, who: rv.author_name, review: rv }; }), Number(parts[1]));
    }
    if ((el = e.target.closest("[data-help]"))) {
      var id = el.dataset.help;
      el.disabled = true;
      el.classList.add("pop");
      try { var h = JSON.parse(localStorage.getItem("lab-helped")) || []; h.push(id); localStorage.setItem("lab-helped", JSON.stringify(h.slice(-300))); } catch (x) {}
      fetch(API + "/hooks/reviews/" + encodeURIComponent(id) + "/helpful", { method: "POST" }).then(function (r) { return r.json(); }).then(function (d) {
        if (d.helpful) el.lastChild.textContent = t("helpful") + " · " + d.helpful;
      }).catch(function () {});
    }
  });
  body.addEventListener("change", function (e) {
    if (e.target.matches("[data-sort]")) { state.sort = e.target.value; state.offset = 0; load(); }
  });
  function findReview(id) {
    for (var i = 0; i < state.list.length; i++) if (state.list[i].id === id) return state.list[i];
    return null;
  }

  /* The rating line under the title scrolls to the reviews. */
  var line = $("[data-p-rate]");
  if (line) line.addEventListener("click", function (e) { e.preventDefault(); sec.scrollIntoView({ behavior: "smooth", block: "start" }); });

  /* Load when the section is close to the screen, or at once for the rating line. */
  load().catch(function () { sec.hidden = true; var l = $("[data-p-rate]"); if (l) l.hidden = true; });

  /* ── the photo viewer ─────────────────────────────────────────────── */
  function viewer(items, start) {
    var i = start;
    var box = document.createElement("div");
    box.className = "rv-view";
    box.setAttribute("role", "dialog");
    box.setAttribute("aria-modal", "true");
    box.innerHTML = '<button type="button" class="rv-x" data-x aria-label="' + t("close") + '">×</button>' +
      '<button type="button" class="rv-nav prev" data-prev aria-label="' + t("prev") + '">‹</button>' +
      '<figure><img alt=""><figcaption></figcaption></figure>' +
      '<button type="button" class="rv-nav next" data-next aria-label="' + t("next") + '">›</button>';
    var img = $("img", box), cap = $("figcaption", box);
    function show() {
      var it = items[i];
      img.src = it.url;
      var r = it.review;
      cap.innerHTML = '<p class="rv-view-c">' + t("of", i + 1, items.length) + "</p>" +
        (r ? stars(r.rating) + (r.title ? "<b>" + esc(r.title) + "</b>" : "") + "<p>" + esc(r.body.length > 220 ? r.body.slice(0, 220) + "…" : r.body) + "</p>" : "") +
        "<p class=\"rv-view-w\"><bdi>" + esc(it.who) + "</bdi>" + (r && r.verified ? " · " + t("verified") : "") + "</p>";
      box.classList.toggle("single", items.length < 2);
    }
    function go(step) { i = (i + step + items.length) % items.length; show(); }
    function close() { document.removeEventListener("keydown", key); box.remove(); document.documentElement.classList.remove("rv-lock"); }
    function key(e) {
      if (e.key === "Escape") close();
      if (e.key === "ArrowRight") go(DIR === "rtl" ? -1 : 1);
      if (e.key === "ArrowLeft") go(DIR === "rtl" ? 1 : -1);
    }
    box.addEventListener("click", function (e) {
      if (e.target.closest("[data-x]") || e.target === box) return close();
      if (e.target.closest("[data-prev]")) return go(-1);
      if (e.target.closest("[data-next]")) return go(1);
    });
    var x0 = null;
    box.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener("touchend", function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go((dx < 0 ? 1 : -1) * (DIR === "rtl" ? -1 : 1));
      x0 = null;
    });
    document.addEventListener("keydown", key);
    document.body.appendChild(box);
    document.documentElement.classList.add("rv-lock");
    show();
    $("[data-x]", box).focus();
  }

  /* ── writing a review ─────────────────────────────────────────────── */
  function shrink(file) {
    var MAX = 1600;
    var draw = function (src, w, h) {
      var k = Math.min(1, MAX / Math.max(w, h));
      var c = document.createElement("canvas");
      c.width = Math.round(w * k);
      c.height = Math.round(h * k);
      c.getContext("2d").drawImage(src, 0, 0, c.width, c.height);
      return c.toDataURL("image/jpeg", 0.82);
    };
    if (window.createImageBitmap) {
      return createImageBitmap(file, { imageOrientation: "from-image" }).then(function (b) { return draw(b, b.width, b.height); });
    }
    return new Promise(function (res, rej) {
      var im = new Image();
      im.onload = function () { res(draw(im, im.naturalWidth, im.naturalHeight)); URL.revokeObjectURL(im.src); };
      im.onerror = rej;
      im.src = URL.createObjectURL(file);
    });
  }

  function openWriter() {
    var sync = FIG.sync;
    var me = FIG.me || {};
    /* Their first name and an initial, which they can change to however they want to be shown. */
    var myName = ((me.first || "") + (me.last ? " " + me.last.charAt(0) + "." : "")).trim();
    var settings = (state.data && state.data.settings) || { max_photos: 4, min_body: 10 };
    var sizes = (sec.dataset.sizes || "").split("|").filter(Boolean);
    var d = document.createElement("div");
    d.className = "fd rv-fd";
    var head = '<div class="fd-head"><span>' + t("write") + '</span><button type="button" data-x aria-label="' + t("close") + '">×</button></div>';
    var product = '<div class="rv-prod">' + (sec.dataset.image ? '<img src="' + esc(sec.dataset.image) + '" alt="">' : "") + "<p>" + esc(sec.dataset.title) + "</p></div>";

    if (!sync) {
      var back = encodeURIComponent(location.pathname + "#reviews");
      var login = (FIG.routes && FIG.routes.login) || "/account/login";
      d.innerHTML = '<div class="fd-scrim" data-x></div><div class="fd-panel" role="dialog" aria-modal="true">' + head +
        '<div class="fd-body"><div class="rv-signin">' + product + "<h3>" + t("f_signin") + "</h3><p>" + t("f_signin_sub") + "</p>" +
        '<a class="btn" href="' + esc(login) + (login.indexOf("?") >= 0 ? "&" : "?") + "return_url=" + back + '">' + t("f_signin_btn") + "</a></div></div></div>";
    } else {
      var pts = settings.points_review || settings.points_photo
        ? '<p class="rv-points">✦ ' + t("f_points", settings.points_review || 0, settings.points_photo || 0) + "</p>" : "";
      d.innerHTML = '<div class="fd-scrim" data-x></div><div class="fd-panel" role="dialog" aria-modal="true">' + head +
        '<form class="fd-body rv-form" novalidate>' + product + pts +
        '<fieldset class="rv-f"><legend>' + t("f_rating") + '</legend><div class="rv-pick" role="radiogroup">' +
        [1, 2, 3, 4, 5].map(function (n) { return '<button type="button" role="radio" aria-checked="false" data-star="' + n + '" aria-label="' + esc(labels[n - 1] || n) + '"></button>'; }).join("") +
        '</div><p class="rv-pick-l" data-star-l>&nbsp;</p></fieldset>' +
        '<label class="rv-f"><span>' + t("f_name") + '</span><input name="name" maxlength="40" autocomplete="nickname" value="' + esc(myName) + '" placeholder="' + esc(t("f_name_ph")) + '"></label>' +
        '<fieldset class="rv-f"><legend>' + t("f_fit") + ' <small>' + t("optional") + '</small></legend><div class="rv-seg">' +
        ["small", "true", "large"].map(function (k) { return '<button type="button" data-fit="' + k + '" aria-pressed="false">' + t("fit_" + k) + "</button>"; }).join("") + "</div></fieldset>" +
        (sizes.length ? '<fieldset class="rv-f"><legend>' + t("f_size") + ' <small>' + t("optional") + '</small></legend><div class="rv-sizes">' +
          sizes.map(function (s) { return '<button type="button" data-size="' + esc(s) + '" aria-pressed="false">' + esc(s) + "</button>"; }).join("") + "</div></fieldset>" : "") +
        '<label class="rv-f"><span>' + t("f_title") + ' <small>' + t("optional") + '</small></span><input name="title" maxlength="120" placeholder="' + esc(t("f_title_ph")) + '"></label>' +
        '<label class="rv-f"><span>' + t("f_body") + '</span><textarea name="body" rows="5" maxlength="3000" placeholder="' + esc(t("f_body_ph")) + '"></textarea></label>' +
        '<fieldset class="rv-f"><legend>' + t("f_photos") + '</legend><p class="rv-sub">' + t("f_photos_sub", settings.max_photos) + '</p><div class="rv-ups" data-ups>' +
        '<label class="rv-add"><input type="file" accept="image/jpeg,image/png,image/webp,image/heic,image/*" multiple hidden><span>+</span></label></div></fieldset>' +
        '<p class="rv-err" data-err role="alert"></p></form>' +
        '<div class="rv-fd-foot"><button type="button" class="btn" data-send>' + t("f_submit") + "</button></div></div>";
    }
    document.body.appendChild(d);
    document.documentElement.classList.add("rv-lock");
    var close = function () { d.remove(); document.documentElement.classList.remove("rv-lock"); };
    d.addEventListener("click", function (e) { if (e.target.closest("[data-x]")) close(); });
    document.addEventListener("keydown", function esc1(e) { if (e.key === "Escape") { close(); document.removeEventListener("keydown", esc1); } });
    if (!sync) return;

    var form = { rating: 0, fit: null, size: null, photos: [] };
    var stl = $("[data-star-l]", d), err = $("[data-err]", d), ups = $("[data-ups]", d), add = $(".rv-add", d);
    var paintStars = function (n) {
      $$("[data-star]", d).forEach(function (b) {
        var on = Number(b.dataset.star) <= n;
        b.classList.toggle("on", on);
        b.setAttribute("aria-checked", Number(b.dataset.star) === form.rating);
      });
      stl.textContent = n ? labels[n - 1] || "" : " ";
    };
    var pick = $(".rv-pick", d);
    pick.addEventListener("mouseover", function (e) { var b = e.target.closest("[data-star]"); if (b) paintStars(Number(b.dataset.star)); });
    pick.addEventListener("mouseleave", function () { paintStars(form.rating); });
    d.addEventListener("click", function (e) {
      var b;
      if ((b = e.target.closest("[data-star]"))) { form.rating = Number(b.dataset.star); paintStars(form.rating); b.classList.add("pop"); setTimeout(function () { b.classList.remove("pop"); }, 300); }
      if ((b = e.target.closest("[data-fit]"))) { form.fit = form.fit === b.dataset.fit ? null : b.dataset.fit; $$("[data-fit]", d).forEach(function (x) { x.setAttribute("aria-pressed", x.dataset.fit === form.fit); }); }
      if ((b = e.target.closest("[data-size]"))) { form.size = form.size === b.dataset.size ? null : b.dataset.size; $$("[data-size]", d).forEach(function (x) { x.setAttribute("aria-pressed", x.dataset.size === form.size); }); }
      if ((b = e.target.closest("[data-rm]"))) { form.photos.splice(Number(b.dataset.rm), 1); paintPhotos(); }
      if (e.target.closest("[data-send]")) send();
    });
    var paintPhotos = function () {
      $$(".rv-up", ups).forEach(function (x) { x.remove(); });
      form.photos.forEach(function (p, i) {
        var el = document.createElement("div");
        el.className = "rv-up";
        el.innerHTML = '<img src="' + p + '" alt=""><button type="button" data-rm="' + i + '" aria-label="' + t("remove_photo") + '">×</button>';
        ups.insertBefore(el, add);
      });
      add.hidden = form.photos.length >= settings.max_photos;
    };
    $("input[type=file]", d).addEventListener("change", function (e) {
      var files = Array.prototype.slice.call(e.target.files || []).slice(0, settings.max_photos - form.photos.length);
      e.target.value = "";
      files.forEach(function (f) {
        var ph = document.createElement("div");
        ph.className = "rv-up loading";
        ups.insertBefore(ph, add);
        shrink(f).then(function (url) { ph.remove(); form.photos.push(url); paintPhotos(); })
          .catch(function () { ph.remove(); err.textContent = t("err_generic"); });
      });
    });

    function send() {
      var title = $("input[name=title]", d).value.trim();
      var shownAs = $("input[name=name]", d).value.trim();
      var text = $("textarea[name=body]", d).value.trim();
      err.textContent = "";
      if (!form.rating) { err.textContent = t("err_rating"); return; }
      if (text.length < (settings.min_body || 10)) { err.textContent = t("err_body"); $("textarea", d).focus(); return; }
      var btn = $("[data-send]", d);
      btn.disabled = true;
      btn.textContent = t("f_sending");
      fetch(API + "/hooks/reviews", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          cid: sync.cid, email: sync.email, sig: sync.sig, first_name: me.first || "", last_name: me.last || "", display_name: shownAs,
          handle: handle, shopify_product_id: sec.dataset.pid, product_title: sec.dataset.title, product_image: sec.dataset.image ? "https:" + sec.dataset.image.replace(/^https?:/, "") : "",
          rating: form.rating, title: title, body: text, fit: form.fit, size_bought: form.size, lang: LANG, photos: form.photos
        })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (x) {
        if (!x.ok) throw new Error(x.j.error || "");
        var panel = $(".fd-panel", d);
        panel.innerHTML = head + '<div class="fd-body"><div class="rv-done"><div class="rv-done-mark" aria-hidden="true"><svg viewBox="0 0 52 52"><circle cx="26" cy="26" r="24"/><path d="M15 27l7 7 15-16"/></svg></div>' +
          "<h3>" + t("done_title", esc((shownAs || me.first || "").split(" ")[0])).replace(/,\s*$/, "") + "</h3><p>" + (x.j.status === "approved" ? t("done_live") : t("done_body")) + "</p>" +
          '<button type="button" class="btn outline" data-x>' + t("close") + "</button></div></div>";
        if (x.j.status === "approved") { state.offset = 0; load(); }
      }).catch(function (e) {
        btn.disabled = false;
        btn.textContent = t("f_submit");
        /* The server explains in English; the Arabic site keeps to its own words. */
        err.textContent = LANG === "en" && e.message && e.message.length < 140 ? e.message : t("err_generic");
      });
    }
  }
})();
